import { EmptyBlock } from '@lmt/unicorn-shared/app/components/patients/profile/overview/components/EmptyBlock';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';
import {
  IncompleteVisitInfo,
  IncompleteVisitItem,
} from './IncompleteVisitItem';
import { groupBy } from 'lodash';
import { getLongMonthDateWithoutYear } from '@lmt/unicorn-shared/app/components/patients/common';

import styles from './IncompleteVisitsPanel.module.scss';

export interface IncompleteVisitsPanelProps {
  incompleteVisits: IncompleteVisitInfo[];
  openPatientTab: (patientId: number) => void;
  openCaseVisitTab: (
    patientId: number,
    caseId: number,
    visitId: number,
  ) => void;
}

export const IncompleteVisitsPanel: React.FC<IncompleteVisitsPanelProps> = (
  props,
) => {
  const { incompleteVisits, openCaseVisitTab, openPatientTab } = props;
  const i18next = useScopedTranslation('dashboard.incomplete_visits');

  if (incompleteVisits.length === 0) {
    return (
      <div className={styles.emptyBlockContainer}>
        <EmptyBlock title={i18next.t('title')} text={i18next.t('empty')} />
      </div>
    );
  }

  const groupedVisits = groupBy(
    incompleteVisits.sort(
      (a, b) => b.startDate!.getTime() - a.startDate!.getTime(),
    ),
    (visit) => getLongMonthDateWithoutYear(visit.startDate),
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>{i18next.t('title')}</div>
      <div className={styles.visits}>
        {Object.keys(groupedVisits).map((createDate) => (
          <div key={createDate} className={styles.dateGroupContainer}>
            <div className={styles.dateTitle}>{createDate}</div>
            <div>
              {groupedVisits[createDate].map((visit) => (
                <div key={visit.id} className={styles.visitContainer}>
                  <IncompleteVisitItem
                    visit={visit}
                    openCaseVisitTab={openCaseVisitTab}
                    openPatientTab={openPatientTab}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
